









import {Component, Prop, Vue} from "vue-property-decorator";

import {Store} from "@/enums/Store";
import {Locale} from "@/enums/Locale";

import {Event} from "@/util/Event";

import {SelectEvent} from "@/store/event";

import {namespace} from 'vuex-class';

import EventInfo from "@/components/Event/EventInfo.vue";

const EVENT = namespace(Store.EVENT);
const APP = namespace(Store.APP);

@Component({
  components: {EventInfo}
})
export default class EventItem extends Vue {
  @Prop({required: true}) event!: Event;

  @APP.State('locale') locale!: Locale;

  @EVENT.Action('selectEvent') selectEvent!: SelectEvent;
}
